// extracted by mini-css-extract-plugin
export default {"container":"AnnotationIcon-module__container--ROeHq","animatedBackground":"AnnotationIcon-module__animatedBackground--Juo7r"};